// Re-export from RegionContext for backward compatibility
import { useRegion, RegionProvider, TRANSLATIONS } from './RegionContext';

// Create a language context that wraps the region context
export const useLanguage = () => {
  const { language, t } = useRegion();
  return { language, t };
};

export const LanguageProvider = RegionProvider;

export default { useLanguage, LanguageProvider };
